import LogService from "@/services/LogService";

/**
 * LoggingPlugin — Plugin Vue para logs do sistema Rifa365.
 *
 * RESPONSABILIDADES:
 *  - Disponibilizar $log (LogService) globalmente em todos os componentes
 *  - Capturar erros globais do Vue
 *
 * Navegação de páginas e login/logout são registrados
 * diretamente via router.afterEach e nos componentes.
 */
export default {
  install(app) {
    // Disponibiliza LogService globalmente como this.$log
    app.config.globalProperties.$log = LogService;
    app.provide("$log", LogService);

    // ── Captura erros globais do Vue ─────────────────────────────────────────
    app.config.errorHandler = (error, _instance, info) => {
      console.error("[Vue Error]", error, info);
      try {
        if (error?.message) {
          LogService.logError(error.message, info);
        }
      } catch {
        // Falha silenciosa para não criar loop de erros
      }
    };
  },
};